var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDisableVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FFF8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14L34 34",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23C16 27.4183 19.5817 31 24 31M24 31C25.9545 31 27.7454 30.2991 29.1348 29.1348M24 31V34M24 34H27M24 34H21M32 23C32 24.6514 31.4996 26.1859 30.6422 27.4603",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0078 18.9956V23.0156C19.0078 25.777 21.2464 28.0156 24.0078 28.0156C25.1432 28.0156 26.1725 27.6252 27.0118 26.9876M28.4465 25.2596C28.8051 24.5701 29.0078 23.8465 29.0078 23.0156V23.0036V18.9956C29.0078 16.2342 26.7692 14.0156 24.0078 14.0156C22.139 14.0156 20.5379 14.9809 19.6798 16.4996",
    stroke: "#EE0033",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDisableVoice);
export default __webpack_public_path__ + "static/media/ic-disable-voice.0f3b082917cfc2a1949cb8e7364b0468.svg";
export { ForwardRef as ReactComponent };